// © Microsoft Corporation. All rights reserved.

import { DesignSystem, isDarkMode } from "@microsoft/fast-components-styles-msft";

export const NavbarStyles = (config: DesignSystem) => ({
    navbarContainer: {
        display: "flex",
        "align-items": "center",
        "justify-content": "space-between",
        padding: "0 16px",

        "& button.cwt-fast-button.cwt-navbar-button": {
            padding: "4px",

            "& .cwt-icon": {
                color: isDarkMode(config) ? "white" : "black",
                "font-size": "16px"
            },

            "& .cwt-icon-white": {
                color: "white"
            }
        }
    }
});